<script setup lang="ts">
import { ConfirmModal } from '@collector/shared-ui'

interface Props {
  maxPlayersInFirstLineup: number
}

defineProps<Props>()
</script>

<template>
  <ConfirmModal>
    <template #title>Are you sure you want to save lineup?</template>
    <div>
      Number of players in 1st lineup is different than
      {{ maxPlayersInFirstLineup }}.
    </div>
  </ConfirmModal>
</template>
